import { OidcSecurityService } from "angular-auth-oidc-client";

import { Injectable, inject } from "@angular/core";

import { OidcAuthenticationConfig } from "../app/auth/types";
import { AuthService } from "./authservice";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  public readonly oidc = inject(OidcSecurityService);
  private readonly auth = inject(AuthService);

  public async setHttpToken() {
    const elevatedToken = await this.oidc.getAccessToken(OidcAuthenticationConfig.SelfService).toPromise();

    if (!!elevatedToken) {
      this.auth.userToken.set(elevatedToken ?? "");
    } else {
      const defaultToken = await this.oidc.getAccessToken(OidcAuthenticationConfig.Default).toPromise();
      this.auth.userToken.set(defaultToken ?? "");
    }
  }
}
